const accountReceivables = [
    {
        "uuid": "1",
        "appNo": "A22012801",
        "appType": "initial",
        "customerName": "源天然股份有限公司",
        "projectManager": "陳阿豪",
        "paymentUnit": "leezen",
        "paymentStatus": "paid",
    },
    {
        "uuid": "2",
        "appNo": "A22012802",
        "appType": "initial",
        "customerName": "源天然股份有限公司",
        "projectManager": "黃阿飛",
        "paymentUnit": "family-freshFood",
        "paymentStatus": "unpaidNotOverdue",
    },
    {
        "uuid": "3",
        "appNo": "A22012803",
        "appType": "initial",
        "customerName": "源天然股份有限公司",
        "projectManager": "李小刀",
        "paymentUnit": "customer",
        "paymentStatus": "unpaidOverdue",
    },
]

export default accountReceivables;